import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, FormGroup, Input, Button, UncontrolledAlert } from 'reactstrap';
import { injectIntl, intlShape } from 'react-intl';
import IntlMessages from 'util/IntlMessages';
import { AccountActions } from '../../../actions';

// Fonction pour valider le format d'email
function isValidEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
}

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: '',
      lastname: '',
      phone_number: '',
      email: '',
      pashword: '',
      confirmPassword: '',
      loading: false,
      success: false,
      errors: {},
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    const updatedState = {
      [name]: value,
      errors: { ...this.state.errors, [name]: null },
    };

    if (
      (name === 'confirmPassword' || name === 'pashword') &&
      this.state.confirmPassword &&
      this.state.pashword &&
      name !== ''
    ) {
      if (
        (name === 'confirmPassword' && value !== this.state.pashword) ||
        (name === 'pashword' && this.state.confirmPassword !== value)
      ) {
        updatedState.errors.confirmPassword = 'Les mots de passe ne correspondent pas.';
      } else {
        updatedState.errors.confirmPassword = null;
      }
    }

    this.setState(updatedState);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { firstname, lastname, phone_number, email, pashword } = this.state;

    this.setState({ loading: true, errors: {} }, () => {
      this.props.signup({
        data: {
          firstname,
          lastname,
          phone_number,
          email,
          pashword,
          delivery_mode: 'HOME',
          delivery_firstname: firstname,
          delivery_lastname: lastname,
          address: '10 rue de Paris',
          postal_code: '75000',
          city: 'Paris',
          group: 'NO_GENETIC',
        },
        cb: (res) => {
          if (res.error ) {
            const errorMap = {};
            res.error.forEach((err) => {
              if(err.field === "email") {
                errorMap[err.field] = "Cet email est déjà utilisé. Veuillez en choisir un autre."
              }else {
                errorMap[err.field] = err.message;
              }
            });
            this.setState({ errors: errorMap, loading: false });
          } else {
            this.setState({ success: true, loading: false });
          }
        },
      });
    });
  };

  render() {
    const isLoggedIn = localStorage.getItem('accessToken') !== null;

    if (isLoggedIn) {
      return <Redirect to="/app/report" />;
    }

    const { intl } = this.props;
    const { firstname, lastname, phone_number, email, pashword, confirmPassword, loading, errors, success } =
      this.state;

    const fieldPlaceholders = {
      firstname: 'Prénom',
      lastname: 'Nom',
      phone_number: 'Numéro de téléphone',
      email: 'Adresse e-mail',
      pashword: 'Mot de passe',
    };

    if (success) {
      return <Redirect to="/login" />;
    }

    return (
      <div className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="login-content">
          <div className="login-header mb-4 text-center">
            <Link className="app-logo" to="/" title="BeDaddy">
              <img src="images/logo.png" alt="BeDaddy" title="BeDaddy" />
            </Link>
          </div>

          <div className="login-form">
            <Form onSubmit={this.handleSubmit}>
              {[
                ['firstname', firstname],
                ['lastname', lastname],
                ['phone_number', phone_number],
                ['email', email],
                ['pashword', pashword],
              ].map(([field, value]) => (
                <FormGroup className="mb-3" key={field}>
                  <Input
                    type={field === 'pashword' ? 'password' : field === 'email' ? 'email' : 'text'}
                    name={field}
                    id={field}
                    value={value}
                    onChange={this.handleChange}
                    required
                    invalid={!!errors[field]}
                    placeholder={fieldPlaceholders[field] || field}
                  />
                  {errors[field] && (
                    <UncontrolledAlert className="bg-danger text-white shadow-sm mt-1">
                      {errors[field]}
                    </UncontrolledAlert>
                  )}
                </FormGroup>
              ))}

              <FormGroup className="mb-3">
                <Input
                  type="password"
                  name="confirmPassword"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={this.handleChange}
                  required
                  invalid={!!errors.confirmPassword}
                  placeholder="Répéter le mot de passe"
                />
                {errors.confirmPassword && (
                  <UncontrolledAlert className="bg-danger text-white shadow-sm mt-1">
                    {errors.confirmPassword}
                  </UncontrolledAlert>
                )}
              </FormGroup>

              <div className="signupbtn-wrapper">
                {loading && (
                  <div className="loading">
                    <svg className="circular" viewBox="25 25 50 50">
                      <circle className="path" cx="50" cy="50" r="15" fill="none" strokeWidth="2" />
                    </svg>
                  </div>
                )}
                <Button className="jr-btn btn-primary btn btn-default" disabled={loading}>
                  <IntlMessages id="appModule.signUp" />
                </Button>
              </div>
            </Form>

            <div className="mt-3 text-center">
              <Link to="/login">
                <IntlMessages id="appModule.alreadyMember" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Signup.propTypes = {
  intl: intlShape.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  signup: (req) => dispatch(AccountActions.signup(req.data, req.cb)),
});

export default connect(null, mapDispatchToProps)(injectIntl(Signup));



// WEBPACK FOOTER //
// ./app/routes/Register/index.js